import { ReactElement } from 'react';
import { Header } from './style';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const MatchHeaderSkeleton = (): ReactElement => {
  return (
    <Header>
      <Skeleton
        active
        round
        title={{ width: '100%', style: { height: 14 } }}
        paragraph={false}
        className="matchHeader__skeleton"
      />
      <Skeleton
        active
        round
        title={{ width: '100%', style: { height: 14 } }}
        paragraph={false}
        className="matchHeader__skeleton"
      />
      <Skeleton
        active
        round
        title={{ width: '100%', style: { height: 14 } }}
        paragraph={false}
        className="matchHeader__skeleton"
      />
    </Header>
  );
};
